import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React, { forwardRef } from 'react';
import cx from 'classnames';
import system from '../../system';
import Base from '../Base';
import Icon from '../Icon';
import Box from '../Box';
import Loader from '../Loader';
import styles from './index.module.css';
import overwriteStyles from '@mediahuis/chameleon-theme-wl/lib/web/overwrites/button.module.css';
const SYSTEM_PROPS = ['flexProps', 'marginProps', 'floatProps'];
const Button = /*#__PURE__*/function () {
  const Button = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      appearance,
      as,
      children,
      disabled,
      iconLeft,
      iconRight,
      size,
      width,
      loading,
      ...props
    } = _ref;
    const isDisabled = disabled || loading;
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    const combinedStyles = {
      ...styles,
      ...overwriteStyles
    };
    const classnames = {
      [combinedStyles.root]: true,
      // size
      [combinedStyles.small]: size === 'small',
      [combinedStyles.large]: size === 'large',
      // appearance
      [combinedStyles.primary]: appearance === 'primary',
      [combinedStyles.secondary]: appearance === 'secondary',
      [combinedStyles.plain]: appearance === 'plain',
      [combinedStyles.outline]: appearance === 'outline',
      // width
      [combinedStyles.full]: width === 'full',
      // disabled
      [combinedStyles.disabled]: isDisabled,
      [combinedStyles.loading]: loading,
      [combinedStyles.extendRoot]: true
    };
    return /*#__PURE__*/React.createElement(Base, _extends({
      as: as,
      className: cx(classnames, className),
      style: style,
      disabled: isDisabled,
      ref: ref
    }, rest), iconLeft && /*#__PURE__*/React.createElement(Icon, {
      as: iconLeft,
      size: "small",
      className: children && styles.iconLeft
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.content
    }, children), iconRight && /*#__PURE__*/React.createElement(Icon, {
      as: iconRight,
      size: "small",
      className: children && styles.iconRight
    }), loading && /*#__PURE__*/React.createElement(Box, {
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      className: styles.loader
    }, /*#__PURE__*/React.createElement(Loader, {
      role: "status",
      size: size === 'small' ? 'small' : 'medium'
    })));
  });
  Button.displayName = 'Button';
  Button.identifier = Button.displayName; // used in docs website
  Button.clonableProps = SYSTEM_PROPS;
  Button.defaultProps = {
    appearance: 'primary',
    as: 'button',
    size: 'large',
    width: 'auto'
  };
  return Button;
}();
export default Button;